export const Orders = {
  DESC: 'desc',
  ASC: 'asc',
} as const;
